function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "27.291%",
  y1: "36.261%",
  x2: "95.682%",
  y2: "77.638%",
  id: "error-illustration-big_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9823",
  offset: "37%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE852A",
  offset: "70%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "error-illustration-big_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4543C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F45D43",
  offset: "24%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F67755",
  offset: "64%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F67D5A",
  offset: "73%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "19.04%",
  y1: "34.736%",
  x2: "103.238%",
  y2: "76.206%",
  id: "error-illustration-big_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF3BD",
  offset: "20%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE6A3",
  offset: "53%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "80%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "error-illustration-big_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4543C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F45D43",
  offset: "24%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F67755",
  offset: "64%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F67D5A",
  offset: "73%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "26.908%",
  y1: "34.736%",
  x2: "89.709%",
  y2: "76.206%",
  id: "error-illustration-big_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF3BD",
  offset: "20%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE6A3",
  offset: "53%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "80%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.17 .098)"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#ABC0D8",
  strokeWidth: 2.779,
  opacity: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 63.809,
  cy: 64.602,
  r: 55.071
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#ABC0D8",
  strokeWidth: 2.779,
  opacity: 0.3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 63.809,
  cy: 64.602,
  r: 42.914
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#ABC0D8",
  strokeWidth: 2.779,
  fill: "#FFF",
  fillRule: "nonzero",
  cx: 33.675,
  cy: 110.57,
  r: 5.319
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F1823B",
  strokeWidth: 2.779,
  cx: 3.799,
  cy: 98.869,
  r: 3.799
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F1823B",
  fillRule: "nonzero",
  cx: 115.628,
  cy: 45.348,
  r: 3.799
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.694 4.382l3.385-3.385a1.056 1.056 0 011.493 0l3.385 3.385c.413.412.413 1.08 0 1.493l-3.385 3.385a1.056 1.056 0 01-1.493 0l-3.385-3.385a1.056 1.056 0 010-1.493zm-32.23 120.813l2.228-2.229a.68.68 0 01.963 0l2.229 2.229a.68.68 0 010 .962l-2.229 2.229a.68.68 0 01-.963 0l-2.228-2.229a.68.68 0 010-.962zM17.69 26.521l2.824-2.823a.875.875 0 011.238 0l2.824 2.823a.875.875 0 010 1.238l-2.824 2.824a.875.875 0 01-1.238 0L17.69 27.76a.875.875 0 010-1.238zm100.556 78.129l2.824-2.824a.875.875 0 011.238 0l2.824 2.824a.875.875 0 010 1.238l-2.824 2.824a.875.875 0 01-1.238 0l-2.824-2.824a.875.875 0 010-1.238z",
  fill: "#FDB913",
  fillRule: "nonzero"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.246 23.105)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M71.52 0c1.151 0 2.084.933 2.084 2.084 0 1.06-.796 1.949-1.882 2.074l-.202.01h-2.704l.002 6.97c15.275 1.07 27.335 13.8 27.335 29.347 0 16.248-13.172 29.42-29.42 29.42s-29.42-13.172-29.42-29.42c0-15.547 12.06-28.278 27.336-29.347l-.001-6.97h-2.702a2.084 2.084 0 01-2.074-1.883l-.01-.2c0-1.062.796-1.95 1.882-2.074L61.946 0z",
  fill: "url(#error-illustration-big_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.302 49.323a1.39 1.39 0 01.162 2.77l-.162.008H7.468a1.39 1.39 0 01-.162-2.769l.162-.01h25.834zM8.987 40.205a1.39 1.39 0 01.163 2.77l-.163.009H1.39a1.39 1.39 0 01-.162-2.77l.162-.01h7.598zm31.913 0a1.39 1.39 0 01.162 2.77l-.162.009H15.066a1.39 1.39 0 01-.162-2.77l.162-.01H40.9zm7.598-9.118a1.39 1.39 0 01.162 2.77l-.162.009H22.664a1.39 1.39 0 01-.162-2.77l.162-.009h25.834zm-31.912 0a1.39 1.39 0 01.162 2.77l-.162.009H8.987a1.39 1.39 0 01-.162-2.77l.162-.009h7.599z",
  fill: "url(#error-illustration-big_svg__b)"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "url(#error-illustration-big_svg__c)",
  cx: 66.733,
  cy: 40.485,
  r: 11.032
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.592 28.464a1.39 1.39 0 012.097 1.815l-.114.132-10.85 11.048a1.39 1.39 0 01-2.097-1.816l.114-.132 10.85-11.047z",
  fill: "url(#error-illustration-big_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.61 63.838c.71 0 1.295.532 1.375 1.218l.009.16v4.177c0 .761-.62 1.378-1.384 1.378-.71 0-1.295-.532-1.375-1.218l-.009-.16v-4.176c0-.762.62-1.379 1.384-1.379zm-16.777-6.923c.499.497.537 1.279.115 1.82l-.115.13-2.967 2.954a1.388 1.388 0 01-1.957 0 1.375 1.375 0 01-.115-1.82l.115-.13 2.967-2.954a1.388 1.388 0 011.957 0zm35.381-.115l.13.115 2.967 2.955c.54.538.54 1.41 0 1.95a1.388 1.388 0 01-1.826.114l-.13-.115-2.968-2.955a1.374 1.374 0 010-1.95 1.388 1.388 0 011.827-.114zm10.701-17.973a1.38 1.38 0 011.384 1.378 1.38 1.38 0 01-1.222 1.37l-.162.008h-4.192a1.381 1.381 0 01-1.384-1.378c0-.707.534-1.29 1.222-1.37l.162-.008h4.192zm-8.758-20.435c.513.514.553 1.322.118 1.88l-.118.135-4.098 4.098a1.425 1.425 0 01-2.133-1.88l.118-.135 4.098-4.098a1.425 1.425 0 012.015 0zm-40.421.084l.13.115 2.967 2.955c.54.538.54 1.41 0 1.95a1.388 1.388 0 01-1.827.114l-.13-.115-2.967-2.955a1.374 1.374 0 010-1.95 1.388 1.388 0 011.827-.114zM66.61 9.64c.71 0 1.295.532 1.375 1.217l.009.161v4.176c0 .762-.62 1.379-1.384 1.379-.71 0-1.295-.532-1.375-1.218l-.009-.16v-4.177c0-.761.62-1.378 1.384-1.378z",
  fill: "url(#error-illustration-big_svg__e)"
})));

function SvgErrorIllustrationBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 130,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgErrorIllustrationBig;